export const MIN_USERS = 20;
export const MID_USERS = 125;
export const MAX_USERS = 250;

export const MIN_PRICE_PER_USER = 14.99;
export const MID_PRICE_PER_USER = 7.99;
export const MAX_PRICE_PER_USER = 5.99;
